var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step-progress" }, [
    _c("h3", { staticClass: "step-title" }, [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("div", { staticClass: "step-content" }, [
      _c(
        "div",
        { staticClass: "steps-list" },
        _vm._l(_vm.steps, function(step, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "step",
              on: {
                click: function($event) {
                  return _vm.goToCallback(index + 1)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "oval",
                  class: {
                    "current-step": index === _vm.currentStep - 1,
                    "step-valid": step.valid && index !== _vm.currentStep - 1,
                    "step-invalid": !step.valid && index !== _vm.currentStep - 1
                  }
                },
                [
                  step.valid && index !== _vm.currentStep - 1
                    ? _c("img", {
                        attrs: {
                          src: require("../../../../assets/img/green-check.svg")
                        }
                      })
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(step.name))])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            { "multi-actions-footer": _vm.isLastStep },
            "step-btn form-footer"
          ]
        },
        [
          _c(
            "button",
            {
              staticClass: "btn-center",
              class: !_vm.isLastStep ? "secondary-btn" : "primary-btn",
              attrs: { disabled: _vm.isDisabled },
              on: { click: _vm.handleNextButton }
            },
            [
              _vm._v(
                "\n                        " +
                  _vm._s(_vm.buttonsLabels[0]) +
                  "\n\n                "
              )
            ]
          ),
          _vm._v(" "),
          _vm.buttonsLabels.length === 2
            ? _c(
                "button",
                {
                  staticClass: "btn-center",
                  class: !_vm.isLastStep ? "secondary-btn" : "primary-btn",
                  attrs: { disabled: _vm.isDisabled },
                  on: {
                    click: function($event) {
                      return _vm.saveDraftCallback(false)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.buttonsLabels[1]) +
                      "\n                "
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4315be48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4315be48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/pages/base/BaseStepList.vue
// module id = null
// module chunks = 